<template>
  <FlotoModule>
    <RouterView :key="$route.fullPath" />
  </FlotoModule>
</template>

<script>
import Constants from '@constants'
import { PageMethods } from '@state/modules/page'
import { LicenseComputed } from '@state/modules/license'
import { PreferenceComputed } from '@state/modules/preference'
export default {
  name: 'ContractsModule',
  page() {
    return {
      title: this.$tc('contract', 2),
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.name.indexOf('create') >= 0) {
      return next((vm) => {
        if (vm.availableModulesInLicense.indexOf(Constants.CONTRACT) === -1) {
          return vm.$router.replace({ name: 'upgrade-plan' })
        }
        if (vm.myAllowedModules.indexOf(Constants.CONTRACT) === -1) {
          return vm.$router.replace({ name: '404' })
        }
      })
    }
    next((vm) => {
      if (vm.availableModulesInLicense.indexOf(Constants.CONTRACT) === -1) {
        return vm.$router.replace({ name: 'upgrade-plan' })
      }
      if (vm.myAllowedModules.indexOf(Constants.CONTRACT) === -1) {
        return vm.$router.replace({ name: '404' })
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    // add any module level clean up logic here
    setTimeout(() => {
      if (this.contractPageReset) {
        this.contractPageReset()
      }
    }, 400)
    next()
  },
  computed: {
    ...LicenseComputed,
    ...PreferenceComputed,
  },
  methods: {
    ...PageMethods,
  },
}
</script>
